import {Model} from '@ab/components';
import queryParams from '../queries/main.m.q';

class Main extends Model {
    static queryParams = queryParams;
}

export default Main;
